<template>
    <div class="granularity-toggle">
        <el-tooltip placement="top">
            <template #content>
                <div class="granularity-tooltip">
                    <strong>Data Aggregation Mode</strong><br>
                    <span class="mode-desc">Total: Sum for time period</span><br>
                    <span class="mode-desc">Per Second: Rate per second (TPS-style)</span><br>
                    <span class="mode-desc">Per Period: Average per {{ periodLabel }}</span>
                </div>
            </template>
            <el-segmented
                v-model="selectedMode"
                :options="options"
                size="small"
                @change="handleChange"
            />
        </el-tooltip>
    </div>
</template>

<script>
import {
    GRANULARITY_MODES,
    GRANULARITY_SHORT_LABELS,
    getPeriodLabel
} from '../composables/useGranularityToggle';

export default {
    name: 'GranularityToggle',

    props: {
        modelValue: {
            type: String,
            default: GRANULARITY_MODES.TOTAL
        },
        interval: {
            type: String,
            default: '1h'
        }
    },

    emits: ['update:modelValue', 'change'],

    data() {
        return {
            selectedMode: this.modelValue
        };
    },

    computed: {
        options() {
            return [
                { value: GRANULARITY_MODES.TOTAL, label: GRANULARITY_SHORT_LABELS[GRANULARITY_MODES.TOTAL] },
                { value: GRANULARITY_MODES.PER_SECOND, label: GRANULARITY_SHORT_LABELS[GRANULARITY_MODES.PER_SECOND] },
                { value: GRANULARITY_MODES.PER_PERIOD, label: `/${this.periodLabel}` }
            ];
        },
        periodLabel() {
            return getPeriodLabel(this.interval);
        }
    },

    watch: {
        modelValue(newVal) {
            this.selectedMode = newVal;
        }
    },

    methods: {
        handleChange(value) {
            // el-segmented may pass value directly or we use selectedMode
            const newValue = value || this.selectedMode;
            this.$emit('update:modelValue', newValue);
            this.$emit('change', newValue);
        }
    }
};
</script>

<style scoped>
.granularity-toggle {
    display: inline-flex;
    align-items: center;
}

.granularity-tooltip {
    font-size: 0.8rem;
    line-height: 1.5;
}

.mode-desc {
    color: rgba(255, 255, 255, 0.7);
    font-size: 0.75rem;
}

:deep(.el-segmented) {
    --el-segmented-bg-color: rgba(139, 92, 246, 0.1);
    --el-segmented-item-selected-bg-color: rgba(139, 92, 246, 0.6);
    --el-segmented-item-selected-color: #fff;
    border: 1px solid rgba(139, 92, 246, 0.4);
    border-radius: 6px;
    background: rgba(139, 92, 246, 0.1);
}

:deep(.el-segmented__item) {
    color: #d1d5db;
    font-size: 0.8rem;
    font-weight: 500;
    padding: 6px 12px;
    transition: all 0.2s ease;
}

:deep(.el-segmented__item:hover) {
    color: #fff;
}

:deep(.el-segmented__item.is-selected) {
    color: #fff;
    font-weight: 600;
}

:deep(.el-segmented__item-selected) {
    background: linear-gradient(135deg, rgba(139, 92, 246, 0.8), rgba(236, 72, 153, 0.6)) !important;
    border-radius: 4px;
}
</style>
